import * as LucideIcons from "lucide-react";

const Icon = Object.assign({}, LucideIcons, {
  icons: LucideIcons,
});

export default Icon;
